import type { GuardMember, MemberStatus } from '../../../src/services/team/roles';
import type { TeamMember } from '../types';

export type TeamFilter = 'all' | MemberStatus;

export function filterMembers(members: TeamMember[], filter: TeamFilter, query: string): TeamMember[] {
  const q = query.trim().toLowerCase();
  return members
    .filter((m) => filter === 'all' || m.status === filter)
    .filter((m) => !q || `${m.name ?? ''} ${m.email}`.toLowerCase().includes(q));
}

export function countByStatus(members: TeamMember[]): Record<TeamFilter, number> {
  return {
    all: members.length,
    active: members.filter((m) => m.status === 'active').length,
    invited: members.filter((m) => m.status === 'invited').length,
    deactivated: members.filter((m) => m.status === 'deactivated').length,
  };
}

export function initialsFor(member: Pick<TeamMember, 'name' | 'email'>): string {
  if (member.name) {
    return member.name
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }
  return member.email.slice(0, 2).toUpperCase();
}

export function displayName(member: Pick<TeamMember, 'name' | 'email'>): string {
  return member.name || member.email;
}

export function toGuard(member: TeamMember): GuardMember {
  return { id: member.id, role: member.role, status: member.status, external: member.external };
}

export const STATUS_PILL: Record<MemberStatus, { label: string; cls: string }> = {
  active: { label: 'Active', cls: 'completed' },
  invited: { label: 'Invited', cls: 'active' },
  deactivated: { label: 'Deactivated', cls: 'unsent' },
};
